import type { AuthProviderType, ThemePreference } from '../../types'

export const AuthProvider: Record<Uppercase<AuthProviderType>, AuthProviderType> = {
  GOOGLE: 'google',
  GITHUB: 'github',
} as const

export const DEFAULT_THEME: ThemePreference = 'system'

export const THEME_OPTIONS: { value: ThemePreference; label: string }[] = [
  { value: 'system', label: 'System' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
]

export const AUTH_PROVIDER_CONFIG = {
  google: { label: 'Google', iconVariant: 'google' as const },
  github: { label: 'GitHub', iconVariant: 'github' as const },
} as const
